<template>
  <div id="principal-modal-avisos">
    <div
      class="modal fade"
      id="modalTerminosAvisos"
      tabindex="-1"
      aria-labelledby="modalAvisoPrivacidad"
      aria-hidden="true"
      style="overflow-y: hidden; max-height: 95%;"
    >
      <div class="modal-dialog modal-lg">
        <div
          class="modal-content modal-aviso"
          style="height: 675px; max-height: 95%; overflow-y: auto;"
        >
          <div class="modal-header">
            <h5 class="modal-title" v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
              AVISO DE PRIVACIDAD PARA CLIENTES Y PROSPECTOS
            </h5>
            <h5 class="modal-title" v-else>
              PRIVACY NOTICE FOR CUSTOMERS AND PROSPECTS
            </h5>
            <button
              v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="CerrarModal"
            ></button>
            <button
              v-else
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="CloseModal"
            ></button>
          </div>
          <div class="modal-body">
            <div class="col-lg-12 center">
              <img
                class="imagen-bienvenida-privacidad"
                src="../../../assets/logo-bienvenida.png"
              />
            </div>
            <div class="contenido-aviso p-3">
              <p v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                De conformidad con lo establecido en la Ley Federal de
                Protección de Datos Personales en Posesión de Particulares, se
                pone a su disposición el presente aviso de privacidad en los
                siguientes términos:
              </p>
              <p v-else>
                In accordance with the provisions of the Federal Law for the
                Protection of Personal Data in Possession of Private Parties,
                this privacy notice is made available to you in the following
                terms:
              </p>
              <strong class="float-none" v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                I. IDENTIFICACIÓN DEL RESPONSABLE.
              </strong>
              <strong class="float-none" v-else>
                I. IDENTIFICATION OF THE RESPONSIBLE PARTY.
              </strong>
              <br /><br />
              <p v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                Mediante el presente AVISO DE PRIVACIDAD, Bienes Programados,
                S.A. de C.V., en lo sucesivo “EL RESPONSABLE”, con domicilio
                para efectos del presente aviso de privacidad en Desierto de los
                Leones No. 46, Planta baja, Col. San Ángel, Álvaro Obregón, C.P.
                01000, Ciudad de México, tiene la calidad de responsable frente
                a los
                <b> clientes o prospectos</b> (en lo sucesivo “Titulares”) de
                sus datos personales.
              </p>
              <p v-else>
                By means of the present PRIVACY NOTICE, Bienes Programados, S.A.
                de C.V., hereinafter “THE RESPONSIBLE”, with address for effects
                of the present privacy notice in Desierto de los Leones No. 46,
                Ground Floor, Col. San Ángel, Álvaro Obregón, C.P. 01000, Mexico
                City, has the quality of responsible before the clients or
                prospects (hereinafter referred to as the “Holders”) of their
                personal data.
              </p>

              <strong class="float-none" v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                II. FINALIDAD DEL TRATAMIENTO DE LOS DATOS PERSONALES:
              </strong>
              <strong class="float-none" v-else>
                II. PURPOSE OF THE PROCESSING OF PERSONAL DATA:
              </strong>
              <br /><br />
              <p v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                “EL RESPONSABLE” hace de su conocimiento que la información de
                los Titulares es tratada de forma estrictamente confidencial,
                por lo que, al proporcionar sus datos personales, serán
                utilizados para:
              </p>
              <p v-else>
                “THE RESPONSIBLE” informs you that the information of the
                Holders is treated in a strictly confidential manner, therefore,
                by providing your personal data, it will be used for:
              </p>
              <ol
                type="1"
                class="contenido-aviso__lista-datos"
                v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)"
              >
                <li>Verificar su identidad e información.</li>
                <li>Integrar su expediente.</li>
                <li>Actualizar nuestra base de datos.</li>
                <li>
                  Analizar su capacidad y calificación crediticia para la
                  contratación del sistema de financiamiento.
                </li>
                <li>Gestionar pagos derivados de su financiamiento.</li>
                <li>
                  Prestar los servicios y llevar a cabo la compra de servicios
                  solicitados por usted de manera remota (incluyendo los
                  servicios de venta por internet).
                </li>
                <li>
                  Informarle y/o contactarle por cualquier medio óptico, sonoro,
                  tecnológico o físico (WhatsApp, SMS, teléfono, correo
                  electrónico, mensajería, entre otros), respecto al estatus de
                  sus compras.
                </li>
                <li>La contratación de seguros.</li>
                <li>La emisión de facturas.</li>
                <li>
                  Videovigilancia dentro de nuestras instalaciones para su
                  seguridad y la del personal que se encuentra en ellas.
                </li>
                <li>
                  Cumplir con la normatividad aplicable y requerimientos de las
                  autoridades con base en Ley para el cumplimiento de las
                  disposiciones legales y requerimientos de diversas autoridades
                  y.
                </li>
                <li>Atender sus dudas, quejas y sugerencias como Titular.</li>
              </ol>

              <ol type="1" class="contenido-aviso__lista-datos" v-else>
                <li>Verify your identity and information.</li>
                <li>Integrate your file.</li>
                <li>Update our database.</li>
                <li>
                  Analyze its capacity and credit rating for the contracting of
                  the financing system.
                </li>
                <li>Manage payments derived from its financing.</li>
                <li>
                  To provide the services and carry out the purchase of services
                  requested by you remotely (including internet sales services
                  including internet sales services).
                </li>
                <li>
                  Inform you and/or contact you by any optical, sound,
                  technological or physical means (WhatsApp, SMS, telephone,
                  email, messaging, among others), regarding the status of your
                  purchases.
                </li>
                <li>The contracting of insurance.</li>
                <li>The issuance of invoices.</li>
                <li>
                  Video surveillance within our facilities for your safety and
                  the safety of your staff.
                </li>
                <li>
                  Comply with the applicable regulations and requirements of the
                  authorities based on the Law for compliance with the legal
                  provisions and requirements of various authorities and.
                </li>
                <li>
                  To attend your doubts, complaints and suggestions as Holder.
                </li>
              </ol>
              <p v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                Adicionalmente, utilizamos su información para comercializar
                nuestros productos que, si bien es cierto, no es necesaria para
                prestarle los servicios y productos que solicita o contrata con
                nosotros, la misma nos permite brindarle un mejor servicio y
                elevar su calidad.
              </p>
              <p v-else>
                In addition, we use your information to market our products,
                although it is true, it is not necessary to provide you with the
                services and products that you request or contract with us, it
                allows us to provide you with a better service and improve its
                quality.
              </p>
              <strong class="float-none" v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                III. MECANISMOS PARA QUE EL TITULAR PUEDA MANIFESTAR SU NEGATIVA
                PARA EL TRATAMIENTO DE DATOS PERSONALES.
              </strong>
              <strong class="float-none" v-else>
                III. MECHANISMS FOR THE HOLDER TO EXPRESS HIS/HER REFUSAL FOR
                THE PROCESSING OF PERSONAL DATA.
              </strong>
              <br /><br />
              <p v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                El Titular que no desee que sus datos personales sean tratados
                para los fines secundarios o accesorios descritos en el presente
                aviso de privacidad, deberá presentar en escrito libre o
                mediante el Formato de Solicitud ARCO, de forma escrita en
                alguna de nuestras sucursales o mediante el envío del escrito
                respectivo a la cuenta de correo protecciondatos@hircasa.com.mx, en
                donde deberá especificar: nombre y domicilio u otro medio para
                comunicarle la respuesta a su solicitud de derechos ARCO;
                agregar los documentos que acrediten su identidad o, en su caso,
                la representación legal del cliente o prospecto, (identificación
                oficial) y la descripción clara y precisa de los datos
                personales respecto de los que se busca ejercer alguno de los
                derechos ARCO, además de cualquier otro documento que facilite
                la localización de los datos personales, en términos del
                artículo 29 de la Ley. La negativa para el uso de sus datos
                personales para las finalidades secundarias no será motivo para
                negarle los servicios y productos que solicita o contrata con
                nosotros.
              </p>
              <p v-else>
                The Holders who does not want his or her personal data to be
                processed for the secondary or accessory purposes described in
                this privacy notice, must be submitted in writing or by means of
                the ARCO Request Form, in writing at any of our branches or by
                sending the respective letter to the following e-mail address:
                protecciondatos@hircasa.com.mx, where you must specify: name and
                address or other means to communicate the response to your
                request for ARCO rights; add the documents proving their
                identity or, as the case may be, legal representation of the
                client or prospect, (official identification) and a clear and
                precise description of the personal data with respect to which
                the user seeks to exercise any of the ARCO rights, in addition
                to any other document that facilitates the location of the
                personal data, in terms of article 29 of the Law. The refusal to
                use your personal data for secondary purposes will not be a
                reason to deny you the services and products you request or
                contract with us.
              </p>
              <strong class="float-none" v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                IV. DATOS PERSONALES QUE SE RECABAN.
              </strong>
              <strong class="float-none" v-else>
                IV. PERSONAL DATA COLLECTED.
              </strong>
              <br /><br />
              <p v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                Para llevar a cabo las finalidades descritas en el presente
                aviso de privacidad, los datos personales que se obtengan de
                manera verbal, por escrito, o a través de medios electrónicos,
                de conformidad con las finalidades para las que otorgué su
                consentimiento, serán los siguientes: i) Datos de
                identificación, ii) Datos de contacto,iii) Datos laborales, iv)
                Datos académicos o profesionales, v)Datos migratorios, vi) Datos
                Patrimoniales y/o financieros, y vii) Datos de Salud.<br />Ahora
                bien, los datos de terceros que, en su caso proporcione, se
                entenderá que cuenta con el consentimiento del Titular de los
                datos personales.
              </p>
              <p v-else>
                In order to carry out the purposes described in this privacy
                notice, the personal data obtained verbally, in writing, or
                through electronic means, in accordance with the purposes for
                which you have given your consent, will bethe following: i)
                Identification data, ii) Contact data, iii) Employment data, iv)
                Academic or professional data, v) Migration data, vi)
                Patrimonial and/or financial data, and vii) Healthcare related
                data. <br />However, the data of third parties that may be
                provided, it will be understood that it has the consent of
                the owner of the personal data.
              </p>
              <strong class="float-none" v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                V. TRANSFERENCIA DE DATOS PERSONALES."
              </strong>
              <strong class="float-none" v-else>
                V. PERSONAL DATA TRANSFER.
              </strong>
              <br /><br />
              <p v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                El Titular faculta al responsable para poder realizar
                transferencia de sus datos a las empresas filiales o
                subsidiarias que sean identificadas o asociadas a “EL
                RESPONSABLE”, así como a sus distribuidores autorizados y/o
                proveedores de servicios con quien tiene relación jurídica, así
                como terceros nacionales o extranjeros, los terceros y
                receptores de datos personales tienen las mismas obligaciones y
                responsabilidades que “EL RESPONSABLE”, para proteger sus datos
                personales de conformidad a lo establecido en el presente aviso
                de privacidad, si usted no manifiesta su oposición para que sus
                datos personales sean transferidos se entenderá que otorgó su
                consentimiento."
              </p>
              <p v-else>
                The Holders authorizes the Data Controller to transfer his/her
                data to affiliated or subsidiary companies that are identified
                or associated with “THE RESPONSIBLE”, as well as its authorized
                distributors and/or service providers with whom it has a legal
                relationship, as well as national or foreign third parties,
                third parties and recipients of personal data have the same
                obligations and responsibilities as “THE RESPONSIBLE”, to
                protect your personal data in accordance with the provisions of
                this privacy notice, if you do not express your opposition to
                the transfer of your personal data, it will be understood that
                you have given your consent.
              </p>
              <strong class="float-none" v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                VI. PROCEDIMIENTO PARA EJERCER LOS DERECHOS ARCO.
              </strong>
              <strong class="float-none" v-else>
                VI. PROCEDURE FOR EXERCISING RIGHTS ARC.
              </strong>
              <br /><br />
              <p v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                El responsable ha adoptado los niveles de seguridad y de
                protección de datos personales de acuerdo a la legislación
                aplicable y vigente en el país, por ello le informamos que usted
                tiene en todo momento el poder de ejercicio de Derechos ARCO de
                acuerdo al siguiente procedimiento:
              </p>
              <p v-else>
                The responsible has adopted the levels of security and
                protection of personal data in accordance with the applicable
                legislation in force in the country, therefore we inform you
                that you have at all times the power to exercise ARCO Rights
                according to the following procedure:
              </p>

              <ol
                type="1"
                class="contenido-aviso__lista-derechos"
                v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)"
              >
                <li>
                  El cliente o prospecto deberá entregar en forma personal el<i>
                    <b>“Formato de Solicitud ARCO”</b></i
                  >
                  en el domicilio ubicado en Desierto de los Leones No. 46,
                  Planta baja, Col.San Ángel, Álvaro Obregón, C.P. 01000, Ciudad
                  de México, o enviarlo al correo protecciondatos@hircasa.com.mx.
                </li>
                <li>
                  El “Formato de Solicitud ARCO”, deberá indicar de forma
                  legible nombre completo y domicilio u otro medio para
                  comunicarle la respuesta a su solicitud de derechos ARCO.
                </li>
                <li>
                  Deberá agregar los documentos que acrediten su identidad o, en
                  su caso, la representación legal del cliente o prospecto,
                  (identificación oficial).
                </li>
                <li>
                  Señalar la descripción clara y precisa de los datos personales
                  respecto de los que se busca ejercer alguno de los derechos
                  ARCO.
                </li>
                <li>
                  Agregar los documentos que faciliten la localización de los
                  datos personales, en términos "del artículo 29 de la Ley.
                </li>
              </ol>

              <ol type="1" class="contenido-aviso__lista-derechos" v-else>
                <li>
                  The client or prospect must personally deliver the ARCO
                  Request Form at the address located at Desierto de los Leones
                  No. 46, Ground Floor, Col. San Ángel, Álvaro Obregón, C.P.
                  01000, Mexico City, or send it to the following e-mail
                  address: protecciondatos@hircasa.com.mx.
                </li>
                <li>
                  The “ARCO Request Form” must legibly indicate your full name
                  and address or other means to communicate the response to your
                  ARCO rights request.
                </li>
                <li>
                  You must add the documents proving their identity or, as the
                  case may be, legal representation of the client or prospect,
                  (official identification).
                </li>
                <li>
                  Indicate the clear and precise description of the personal
                  data with respect to which you are seeking to exercise any of
                  the ARCO rights.
                </li>
                <li>
                  Add the documents that facilitate the location of the personal
                  data, in terms of article 29 of the Law.
                </li>
              </ol>

              <p v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                La respuesta a su solicitud de Derechos ARCO se le hará llegar
                dentro del término de 20 días hábiles contados a partir de la
                recepción de dicha solicitud, por otro lado, se le informa que
                el derecho de acceso se tendrá por cumplido cuando se haga
                llegar la respuesta correspondiente a través del correo
                proporcionado. El plazo podrá ser ampliado una sola vez por un
                periodo igual, siempre y cuando así lo justifiquen las
                circunstancias del caso.
              </p>
              <p v-else>
                The response to your request for ARCO Rights will be sent within
                20 business days from the receipt of such request, on the other
                hand, you are informed that the right of access will be
                considered fulfilled when the corresponding response is sent
                through the mail provided. The term may be extended once for an
                equal period, provided that the circumstances of the case
                justify it.
              </p>
              <p v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                Es importante que considere que al solicitar la cancelación de
                sus datos personales se generará un periodo de bloqueo y de
                supresión de sus datos, sin embargo, en términos del artículo 25
                de la Ley de la materia, “EL RESPONSABLE” podrá conservarlos
                únicamente para cumplir obligaciones nacidas del tratamiento de
                los mismos.
              </p>
              <p v-else>
                It is important to consider that upon requesting the
                cancellation of your personal data, a period of blocking and
                deletion of your data will be generated, however, in terms of
                Article 25 of the Law of the matter, “THE RESPONSIBLE” may keep
                them only to fulfill obligations arising from the processing of
                the same.
              </p>
              <strong class="float-none" v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                VII. USO DE COOKIES.
              </strong>
              <strong class="float-none" v-else> VII. USE OF COOKIES. </strong>
              <br /><br />
              <p v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                “EL RESPONSABLE” puede utilizar de forma directa o indirecta
                “Cookies” y “Web Beacons”, por tal motivo se le informa a los
                Titulares que, en todo momento, pueden deshabilitar el uso de
                estos mecanismos, de acuerdo a las instrucciones que cada
                persona propietaria de los browsers (navegador o visor de
                internet) tiene implementado para activar y desactivar las
                citadas Cookies.
              </p>
              <p v-else>
                “THE RESPONSIBLE” may directly or indirectly use “Cookies” and
                “Web Beacons”, for this reason the Holders are informed that, at
                any time, they can disable the use of these mechanisms,
                according to the instructions that each person owner of the
                browsers (browser or internet viewer) has implemented to
                activate and deactivate the aforementioned Cookies.
              </p>

              <strong class="float-none" v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                VIII. VIDEO VIGILANCIA
              </strong>
              <strong class="float-none" v-else>
                VIII. VIDEO SURVEILLANCE
              </strong>
              <br /><br />
              <p v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                Le informamos que el responsable cuenta con sistemas de video
                vigilancia al interior y exterior de sus oficinas y sucursales.
                Las imágenes captadas por las cámaras serán utilizadas por
                seguridad del Titular, así como para el monitoreo y control de
                acceso físico a sus instalaciones.
              </p>
              <p v-else>
                We inform you that the responsible party has video surveillance
                systems inside and outside its offices and branches. The images
                captured by the cameras will be used for the security of the
                Holder, as well as for the monitoring and control of physical
                access to its facilities.
              </p>
              <strong class="float-none" v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                IX. MODIFICACIÓN AL AVISO DE PRIVACIDAD.
              </strong>
              <strong class="float-none" v-else>
                IX. MODIFICATION TO THE PRIVACY NOTICE.
              </strong>
              <br /><br />
              <p v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
                El presente aviso de privacidad puede sufrir modificaciones,
                cambios o actualizaciones derivadas de nuevos requerimientos
                legales; de nuestras propias necesidades por los productos o
                servicios que ofrecemos, de cambios en nuestro modelo de negocio
                o por otras causas, dichas modificaciones serán informadas
                mediante aviso físico en nuestras sucursales, a través de
                internet www.hircasa.com.mx o por cualquier otro medio impreso o
                electrónico.<br /><br />
                Fecha de última actualización 27 de septiembre de 2021.
              </p>
              <p v-else>
                This privacy notice may undergo modifications, changes or
                updates derived from new legal requirements; our own needs for
                the products or services we offer, changes in our business model
                or other causes, such modifications will be informed by physical
                notice in our branches, through internet www.hircasa.com.mx or by
                any other printed or electronic means.<br /><br />Last updated
                on September 27, 2021.
              </p>
            </div>
          </div>
          <div class="modal-footer" v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
            <button
              type="button"
              class="modal-aviso__boton"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
          </div>
          <div class="modal-footer" v-else>
            <button
              type="button"
              class="modal-aviso__boton"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalTerminosAvisos",
  props: {
    texto: String,
    titulo: String,
  },
  data() {
    return {
      tipoPersona: null,
    };
  },
  mounted() {
    this.tipoPersona = this.$store.getters.tipoPersona;
  },
};
</script>

<style lang="scss" scoped>
.imagen-bienvenida-privacidad {
  margin-top: 2%;
  width: 271px;
  height: 130px;
}
//MODAL AVISO
#principal-modal-avisos {
  font-family: Poppins;
}
#principal-modal-avisos .modal-aviso {
  border-radius: 0px;
  height: auto;
}
#principal-modal-avisos .modal-archivo__encabezado {
  border-style: none;
}

#principal-modal-avisos .modal-aviso__boton {
  width: 15%;
  height: 50px;
  cursor: pointer;
  color: white;
  background: #b8725a;
  border-radius: 0px;
  border-style: none;
}
#principal-modal-avisos .modal-aviso__boton:hover {
  background: #9b7946;
}

#principal-modal-avisos .contenido-aviso p {
  text-align: justify;
}
#principal-modal-avisos .contenido-aviso strong {
  float: left;
}
#principal-modal-avisos .contenido-aviso__lista-datos {
  list-style: lower-latin;
  text-align: left;
}
#principal-modal-avisos .contenido-aviso__lista-derechos {
  text-align: left;
}

@media all and (max-width: 767px) {
  #principal-modal-avisos .modal-aviso__boton {
    width: 30%;
  }
}
</style>
